import { useEffect, useRef } from "react";

//Redux
import { useSelector } from "react-redux"; //useDispatch

const GoogleAd = ({
  adSlot,
  adFormat = "auto",
  style = {},
  className = "",
  responsive = true,
}) => {
  const adRef = useRef(null);
  const appConfig = useSelector((state) => state?.app?.appConfig); // Application Details from Store

  useEffect(() => {
    try {
      if (
        typeof window !== "undefined" &&
        adRef.current &&
        !adRef.current.getAttribute("data-ad-loaded")
      ) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        adRef.current.setAttribute("data-ad-loaded", "true");
        console.log(">> Google Ads Pushed >>");
      }
    } catch (e) {
      console.error("Adsense error", e);
    }
    
  }, [appConfig]);

  return (
    <div>
      {appConfig?.googleAd ? (
        <ins
          ref={adRef}
          className={`adsbygoogle ${className}`}
          style={{ display: "block", ...style }}
          data-ad-client="ca-pub-7094975150553117"
          data-ad-slot={adSlot}
          data-ad-format={adFormat}
          data-full-width-responsive={responsive ? "true" : "false"}
        />
      ) : (
        ""
      )}

      {/* <GoogleAd
        adSlot="5913495590" // replace with your actual ad slot ID
        adFormat="auto"
        style={{ textAlign: "center", margin: "20px 0" }}
      /> */}
    </div>
  );
};

export default GoogleAd;
